var React = require('react');

function MobileMenuWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33301 17H22.6663M1.33301 1H22.6663H1.33301ZM1.33301 9H22.6663H1.33301Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MobileMenuWhiteInline.defaultProps = {"width":"24","height":"18","viewBox":"0 0 24 18","fill":"none"};

module.exports = MobileMenuWhiteInline;

MobileMenuWhiteInline.default = MobileMenuWhiteInline;
